import React from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";
import UtahHousingMap from "../components/UtahHousing/UtahHousingMap";

const UtahHousing = () => {
  return (
    <>
      <div>
        <LandingSection
          data={{
            imageName: "housing.webp",
            title: "Utah Housing",
            visible: "",
          }}
        />
        <div className="verticals_section">
          <div className="verticals-intro">
            <div className="verticals-intro-sec1">
              <h2>
                Utah's Housing Market: Growth and Affordability Challenges,
                Balancing Demand, Development, and Livability
              </h2>
            </div>
            <div className="verticals-intro-sec2">
              <p>
                Utah's housing market has experienced significant changes in
                recent years, driven by rapid population growth, a strong
                economy, and limited housing supply.Cities like Salt Lake City,
                Provo, and St. George have seen rising home prices and increased
                demand for both single-family homes and multi-family units.
              </p>
              <ActionButton
                data="Explore More"
                link="https://www.realtor.com/"
              />
            </div>
          </div>
        </div>
        <UtahHousingMap />
        <Footer />
      </div>
    </>
  );
};

export default UtahHousing;
